
export default [{
  path: 'clientdocument',
  name: 'companydocument-client',
  component: () => import('@/app/clientarea-app/client-document/ClientDocumentView'),
  meta: {
  }
}]
